import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { deriveMaterialForHyper3d } from './deriveMaterialForHyper3d'
import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Hyper3D image-to-3d-gen2 run.
 * Reads the input image from inputAssets, maps targetPolycount/polygonType
 * from the run, derives material from the stored materialMode, infers
 * modelFormatOutput from the generated 3d_model URL when not explicit, and
 * opens the model settings panel.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseHyper3dImageTo3dGen2Data = (openedModel) => {
  const {
    id: sessionId,
    generatorSessionId,
    modelFormatOutput: rawModelFormatOutput,
    inputAssets,
    outputAssets,
    private: isPrivate,
    useCase,
  } = openedModel

  const {
    polyCount: targetPolycount,
    topology: polygonType,
    materialMode,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterialForHyper3d(materialMode)
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getAssetByTypeAndSource(inputAssets, 'image', 'user_upload')
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const generationProvider = PROVIDER.TRIPO3D
  const generationAction = ACTION.IMAGE_TO_3D
  const isSmartLowPoly = false

  const schema = { generationAction, generationProvider }
  const generation = { sessionId, generatorSessionId }
  const modelSettings = {
    material,
    targetPolycount,
    polygonType,
    inputImage,
    inputImageUrl,
    isPrivate,
    isSmartLowPoly,
    selectedUseCase: useCase,
  }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const ui = {
    isModelSettingsOpen: true,
    isViewerSidebarOpen: false,
    activeViewerSidebarTab: undefined,
  }

  return {
    openedModel,
    schema,
    modelSettings,
    ui,
    generation,
    viewer,
  }
}
